// ============================================================================
// SHORTAGE BOARD ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/ShortageBoard';

export const shortageEndpoints = {
  /** GET — short nights, exposed stays, levers and recorded decisions. */
  board: () => buildEndpoint(BASE_PATH),
  /** POST — opens the plan for a category + span, returning the existing one if any. */
  plans: () => buildEndpoint(`${BASE_PATH}/plans`),
  plan: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/plans/:id`, { id }),
  /** POST — records or re-records the decision for one booking on one night. */
  planDetails: () => buildEndpoint(`${BASE_PATH}/plan-details`),
  planDetail: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/plan-details/:id`, { id }),
  /** POST — stamps what was actually done. Never touches inventory. */
  executeDetail: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/plan-details/:id/execute`, { id }),
  abandonDetail: (id: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/plan-details/:id/abandon`, { id }),
} as const;

export default shortageEndpoints;
